import { FC } from 'react';
import { Tag } from '@carbon/react';
import type { AddressMatchedOn, SubclusterStatus } from '../types';
import {
  STATUS_META,
  subclusterAddressTag,
  type TagColor,
} from '../status-vocabulary';
import styles from '../page.module.scss';

// Included and excluded anchor the scale as black and outline; a partial group
// wears amber (Carbon ships no yellow Tag, so warm-gray is tinted). Label and
// colour come from the one status vocabulary.
export const AddressStatusTag: FC<{ status: SubclusterStatus }> = ({
  status,
}) => {
  const meta = STATUS_META[status];
  if (!meta)
    return (
      <Tag type="gray" size="sm">
        {status}
      </Tag>
    );
  return (
    <Tag
      type={meta.color.addresses}
      size="sm"
      className={meta.amber ? styles.amberTag : undefined}
    >
      {subclusterAddressTag(status)}
    </Tag>
  );
};

const MATCHED_ON: Record<AddressMatchedOn, { label: string; type: TagColor }> =
  {
    identical: { label: 'Identical text', type: 'teal' },
    standardized: { label: 'Standardized', type: 'purple' },
  };

export const MatchedOnTag: FC<{ value: AddressMatchedOn }> = ({ value }) => {
  const meta = MATCHED_ON[value];
  if (!meta) return null;
  return (
    <Tag type={meta.type} size="sm">
      {meta.label}
    </Tag>
  );
};
